import useAspidaSWR from '@aspida/swr'
import React from 'react'
import { toast } from 'react-hot-toast'

import { useApiClient } from '@/hooks/useApiClient'

export const useGetWorkDetail = (workId: string, isWebViewMode: boolean) => {
  const { apiClient, isReady } = useApiClient()

  const workDetail = useAspidaSWR(apiClient.works._workId(workId), {
    enabled:
      isReady ||
      !isWebViewMode ||
      process.env.NEXT_PUBLIC_WEBVIEW_DEBUG === 'true',
  })

  React.useEffect(() => {
    if (workDetail.error) {
      toast.error('サーバーとの通信に失敗しました')
    }
  }, [workDetail.error])

  return {
    ...workDetail,
    data: workDetail.data,
  }
}
